/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { MossRecipient, VerifiedSourceAccountDto } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class BeneficiaryBankAccountControllerV2<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags beneficiary-bank-account-controller-v-2
   * @name GetWalletVerifiedSourceAccountsForCurrentOrganisationId
   * @request GET:/api/v1/wallets/{walletId}/bank-accounts/verified-source-accounts
   */
  getWalletVerifiedSourceAccountsForCurrentOrganisationId = (
    walletId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<VerifiedSourceAccountDto[], any>({
      path: `/v1/wallets/${walletId}/bank-accounts/verified-source-accounts`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getWalletVerifiedSourceAccountsForCurrentOrganisationIdPath =
    '/v1/wallets/${walletId}/bank-accounts/verified-source-accounts'
  static getWalletVerifiedSourceAccountsForCurrentOrganisationIdMethod = 'GET'
  /**
   * No description
   *
   * @tags beneficiary-bank-account-controller-v-2
   * @name GetWalletBeneficiaryBankAccountForCurrentOrganisation
   * @request GET:/api/v1/wallets/{walletId}/bank-accounts/beneficiary
   */
  getWalletBeneficiaryBankAccountForCurrentOrganisation = (
    walletId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<MossRecipient, any>({
      path: `/v1/wallets/${walletId}/bank-accounts/beneficiary`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getWalletBeneficiaryBankAccountForCurrentOrganisationPath =
    '/v1/wallets/${walletId}/bank-accounts/beneficiary'
  static getWalletBeneficiaryBankAccountForCurrentOrganisationMethod = 'GET'
}
